@if (data()) {
  <div class="px-3 pt-1 pb-3 md:px-5 md:pb-5 flex flex-column">
    <!-- Back button -->
    <button
      type="button"
      class="back-link tap-target inline-flex align-items-center cursor-pointer"
      (click)="routeToClients()"
    >
      <app-arrow stroke="#7E838F" direction="left" width="12" height="12" class="mr-2 flex"></app-arrow>
      <div class="label text-sm-semibold text-gray-500">Svi klijenti</div>
    </button>

    <!-- Header: avatar + name/badge + contact (avatar above the text on phones, so long e-mails fit) -->
    <div class="flex flex-column align-items-start sm:flex-row sm:align-items-center gap-3">
      <div class="avatar">
        @if (data()?.isCompany) {
          <app-building-05 stroke="#414651" width="26" height="26"></app-building-05>
        } @else {
          <app-user-circle stroke="#414651" width="26" height="26"></app-user-circle>
        }
      </div>
      <div class="flex flex-column gap-2 min-w-0">
        <div class="flex align-items-center flex-wrap gap-2">
          <div class="display-xs-semibold text-gray-900">{{ data()?.name }}</div>
          @if (data()?.isCompany) {
            <p-chip label="Pravno lice" class="white md"></p-chip>
          } @else {
            <p-chip label="Fizičko lice" class="white md"></p-chip>
          }
        </div>
        <div class="contact-row flex flex-wrap align-items-center">
          <div class="flex align-items-center gap-2 min-w-0">
            <app-mail-02 class="flex-shrink-0" stroke="#ADB0B8" width="16" height="13"></app-mail-02>
            <span class="contact-value text-sm-medium text-gray-600">{{ data()?.email }}</span>
          </div>
          <div class="flex align-items-center gap-2">
            <app-phone stroke="#ADB0B8" width="16" height="16"></app-phone>
            <span class="text-sm-medium text-gray-600">{{ data()?.phone || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs-wrapper mt-5">
      <p-tabs class="transparent compact-tabs" [value]="activeTab()" (valueChange)="onTabChange($event)">
        <p-tablist>
          <p-tab [value]="0">
            <div class="flex align-items-center gap-2">
              <app-cube-01
                [stroke]="activeTab() === 0 ? '#181D27' : '#7E838F'"
                width="16px"
                height="16px"
              ></app-cube-01>
              <span class="text-sm-semibold">Paketi</span>
            </div>
          </p-tab>
          <p-tab [value]="1">
            <div class="flex align-items-center gap-2">
              <app-calendar
                [stroke]="activeTab() === 1 ? '#181D27' : '#7E838F'"
                width="16px"
                height="16px"
              ></app-calendar>
              <span class="text-sm-semibold">Termini</span>
            </div>
          </p-tab>
          <p-tab [value]="2">
            <div class="flex align-items-center gap-2">
              <app-info-circle
                [stroke]="activeTab() === 2 ? '#181D27' : '#7E838F'"
                width="16px"
                height="16px"
              ></app-info-circle>
              <span class="text-sm-semibold">{{ data()?.isCompany ? 'O kompaniji' : 'O klijentu' }}</span>
            </div>
          </p-tab>
        </p-tablist>
      </p-tabs>
    </div>

    <!-- Tab content -->
    <div class="mt-4">
      @switch (activeTab()) {
        @case (0) {
          @if (id()) {
            @if (data()?.isCompany) {
              <app-admin-client-packages-tab [clientId]="id()!"></app-admin-client-packages-tab>
            } @else {
              <app-admin-client-individual-package-tab [clientId]="id()!"></app-admin-client-individual-package-tab>
            }
          }
        }
        @case (1) {
          @if (id()) {
            <app-admin-client-termini-tab [clientId]="id()!"></app-admin-client-termini-tab>
          }
        }
        @case (2) {
          @if (data()) {
            <app-admin-client-about-tab [data]="data()!"></app-admin-client-about-tab>
          }
        }
      }
    </div>
  </div>
}
